module.exports = __webpack_public_path__ + "static/media/fsc-logo.d915dd80.png";